import { MVR_CONSTANTS } from 'wmic-pe-portals-utils-js';

function getMVRReportStatus(reportSource, orderedMVRStatus) {
    if (!reportSource || !orderedMVRStatus) {
        return '';
    }

    return reportSource === MVR_CONSTANTS.MVR_SOURCE.CGI
        ? MVR_CONSTANTS.MVR_ORDER_STATUSES_TEXT[orderedMVRStatus]
        : MVR_CONSTANTS.MVR_ORDER_STATUSES_TEXT.Received;
}

export default {
    getMVRReportStatus
};
